// Receive an file object with name and url and generates
// a dynamic link for that file which initiates a download upon calling the function
export const fileOpenMethod = ({ name, url, newTab = true }) => {
  if (!url) return false

  const link = document.createElement('a')

  link.href = url
  link.download = name

  if (newTab)
    link.target = '_blank'

  document.body.appendChild(link)

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  )

  document.body.removeChild(link)
  return true
}

export const openMethodWithBlob = async ({ url, name }) => {
  try {
    if (!url) return false

    const response = await fetch(url, { cache: 'no-store' })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
    return true
  } catch (error) {
    console.error('Failed to download file:', error)
    return false
  }
}
